import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/OctahedronGeometry'

export default meshComponent('Octahedron', props, createGeometry)
